import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import { lookaheadActions } from '../../actions/lookahead.actions'
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux'
import DialogActions from '@material-ui/core/DialogActions';
import { connect } from 'react-redux'
import { isDeletePPCDialogOpen, getDeletePPCId } from '../../selectors/phaseplan.selector';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ThunkDispatch } from 'redux-thunk';

interface Props {
  isDeletePPCDialogOpen: boolean;
  closeDialogValue: () => void;
  classes: ClassNameMap,
  commitmentId: string
}

type State = {

}

class DeletePPCReportDialog extends Component<Props, State> {

  closeDialog = () => {
    const { closeDialogValue } = this.props
    closeDialogValue()
  }

  onConfirm = () => {
    const { closeDialogValue, commitmentId, deleteCommitment } = this.props

    deleteCommitment(commitmentId)
    closeDialogValue()
  }

  renderContent() {
    const { classes } = this.props;
    return (
        <React.Fragment>
          <DialogContent>
            <div className={classNames(classes.deleteDialog)}>
                Are you sure you want to delete this Commitment?
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} color="primary"> Cancel </Button>
            <Button onClick={this.onConfirm} color="secondary"> Delete </Button>
          </DialogActions>
        </React.Fragment>
    )
  }

  render() {
    const { isDeletePPCDialogOpen } = this.props;
    return (
      <Dialog
        open={isDeletePPCDialogOpen}
        onBackdropClick={this.closeDialog}
      >
        {this.renderContent()}
      </Dialog>
    )
  }
}

const mapStateToProps = (state:any) => ({
  isDeletePPCDialogOpen: isDeletePPCDialogOpen(state),
  commitmentId: getDeletePPCId(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
      closeDialogValue: () => dispatch(lookaheadActions.closeDeletePPCDialog()),
      deleteCommitment: (commitmentId:string) =>  dispatch(lookaheadActions.deleteCommitment(commitmentId))
  }
};


export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(DeletePPCReportDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/DeletePPCReportDialog.tsx